import React, { useContext } from "react"
import tw from "twin.macro"
import { DistanceSliderProps } from "./DistanceSlider.d"
import { parseDisclaimerBlocks } from "../../../helpers"
import { toggleDisclaimersModal } from "../../../contexts/Disclaimers/actions"
import { LanguageContext } from "../../../contexts/Language"
import { LocationContext } from "../../../contexts/Location"
import { DisclaimersContext } from "../../../contexts/Disclaimers"

const DistanceSlider: React.FC<DistanceSliderProps> = ({
  onChange,
  radius,
  fromInventory = false,
}) => {
  const { _ } = useContext(LanguageContext)
  const [{ zip }] = useContext(LocationContext)
  const [, dispatch] = useContext(DisclaimersContext)

  const handleRadiusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e)
  }

  const getDistanceText = () => {
    if (radius === 600) {
      return (
        <>
          {fromInventory
            ? _("View all inventory in the Southeast")
            : _("View all dealers in the Southeast")}
          <span css={tw`font-bold text-base`}>
            {parseDisclaimerBlocks(`[radius_popover]`, code =>
              dispatch(toggleDisclaimersModal(code)),
            )}
          </span>
        </>
      )
    }
    return (
      <>
        <span css={tw`font-bold text-base md:text-lg`}>{radius}</span>{" "}
        {`${_("miles")}`} from {zip}
      </>
    )
  }

  return (
    <div css={tw`relative w-full`}>
      <div css={tw`mb-0 lg:(mb-0)`}>
        <div css={tw`mt-1 text-sm md:text-lg`}>{getDistanceText()}</div>
      </div>
      <div css={tw`relative w-full h-5`}>
        <input
          type="range"
          min="25"
          max="600"
          onChange={handleRadiusChange}
          value={radius}
          css={[
            tw`appearance-none w-full h-[2px] bg-red-400 rounded-full cursor-pointer transition-colors duration-200 ease-in-out`,
            `&::-webkit-slider-thumb {
              -webkit-appearance: none;
              width: 1rem;
              height: 1rem;
              border-radius: 100%;
              background-color: #fff;
              box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.4);
            }`,
            `&::-moz-range-thumb {
              -webkit-appearance: none;
              width: 1rem;
              height: 1rem;
              border-radius: 100%;
              background-color: #fff;
              box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.4);
            }`,
            `&::-ms-thumb {
              -webkit-appearance: none;
              width: 1rem;
              height: 1rem;
              border-radius: 100%;
              background-color: #fff;
              box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.4);
            }`,
          ]}
        />
      </div>
    </div>
  )
}

export default DistanceSlider
